import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {SaleRetrocessionSummaryModel} from '../saleRetrocessionSummary.model';
import {UserSummaryConverter} from '../../../../../../account/modules/user/api/converter/userSummary.converter';
import {Injectable} from '@angular/core';

@Injectable()
export class SaleRetrocessionSummaryConverter extends HttpModelConverter<SaleRetrocessionSummaryModel> {

    protected createInstance(): SaleRetrocessionSummaryModel {
        return new SaleRetrocessionSummaryModel();
    }

    protected enrichObject(result: SaleRetrocessionSummaryModel, src: SaleRetrocessionSummaryModel) {
        result.user = new UserSummaryConverter().convert(src.user);
    }

}

